import config from '../config';
import {
  getProjectsList,
  getDynamicFields,
  addNewWO,
  getTaskByID,
  getPaintList,
  getPreViewHtml,
  archiveTask,
  getCommentsList,
  getSalesPersonsList,
  addComment,
  actionGetHistoryPosition,
  actionGetHistoryStatus,
  actionGetHistoryCreated,
  actionGetHistoryUpdated,
  actionGetHistoryView,
  setTaskAttachments,
  actionDeleteAttachment,
  sendSupplierEmail,
} from '../actions/tasks';
import {
  removeTaskFromArchive
} from '../actions/archive';
import fetch2 from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function getList() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getProjectsList({ list: json }));
          }
        })
    }
  }
};

export function getHistory(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/${id}/1`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryUpdated({
              historyUpdated: text,
            }));
          }
        })
    }
  }
};

export function getPaintListAll() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/getPaintListAll`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getPaintList({ paintListAll: json }));
          }
        })
    }
  }
}

export function deleteAttachmentById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/attachments/${data.id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(notify({
              title: 'Delete Attachment',
              message: 'Attachment deleted successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            dispatch(actionDeleteAttachment({ deleteAttachment: data.id }));
          } else {
            dispatch(notify({
              title: 'Delete Attachment',
              message: 'Failed to delete attachment',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function uploadAttachmentData(id, formData, qc) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      if(qc) formData.append('type', 1);
      return fetch2(`${config.apiEndpoint}/attachments/${id}`, {
        method: 'POST',
        headers: {
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin',
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(notify({
              title: 'Upload Attachment',
              message: 'Attachment uploaded successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            dispatch(getAttachmentsById(id));
          } else {
            dispatch(notify({
              title: 'Upload Attachment',
              message: 'Failed to upload attachment',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};

export function getAttachmentsById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/attachments/getAttachments/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(setTaskAttachments({ currentAttachments: json }));
          }
        })
    }
  }
}

export function updateTaskById(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json && json.updated) {
            dispatch(notify({
              title: 'Edit Work Order',
              message: 'Work order edited successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            setTimeout(() => {window.location.reload();}, 1000);
          }
          else if (json && json.error) {
            if (json.error.exists !== null) {
              dispatch(notify({
                title: 'Update work order',
                message: 'Work order with this name already exists',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
              setTimeout(() => {window.location.reload();}, 1000);
            }
          }
          else {
            setTimeout(() => {window.location.reload();}, 1000);
          }
        })
    }
  }
};

export function updateTaskByIdAndSendMail(id, data, supId) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json && json.updated) {
            fetch2(`${config.apiEndpoint}/task/sendVendorSuppliesEmail/${id}/${supId}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `bearer ${userAuth.api_token}`
              },
              credentials: 'same-origin'
            })
              .then((response) => {
                return response.json();
              })
              .then((response) => {
                if (response.status === 'ok') {
                  dispatch(sendSupplierEmail(supId));
                } else {
                  dispatch(notify({
                    title: 'Send email',
                    message: 'Failed to send email',
                    status: 'error',
                    position: 'tr',
                    dismissible: true,
                    dismissAfter: 3000
                  }));
                }
              })
              .catch(() => {
                dispatch(notify({
                  title: 'Send email',
                  message: 'Failed to send email',
                  status: 'error',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              })
          }
        })
        .catch(() => {
          dispatch(notify({
            title: 'Send email',
            message: 'Failed to send email',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getHistoryPosition(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/getHistoryPosition/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryPosition({
              historyPosition: text,
            }));
          }
        })
    }
  }
};

export function getHistoryStatus(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/getHistoryStatus/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryStatus({
              historyStatus: text,
            }));
          }
        })
    }
  }
}

export function getHistoryCreated(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/getHistoryCreated/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryCreated({
              historyCreated: text,
            }));
          }
        })
    }
  }
}

export function getHistoryUpdated(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/getHistoryUpdated/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryUpdated({
              historyUpdated: text,
            }));
          }
        })
    }
  }
}

export function getHistoryView(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskHistory/getHistoryView/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(actionGetHistoryView({
              historyView: text,
            }));
          }
        })
    }
  }
}

export function getListOfComments(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskComment/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getCommentsList({ comments: json }));
          }
        })
    }
  }
};

export function addCommentToTask(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/taskComment/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json && json.result == 'success') {
            dispatch(notify({
              title: 'Add Comment',
              message: 'Comment added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
            dispatch(addComment(json.comment));
          } else {
            dispatch(notify({
              title: 'Add Comment',
              message: 'Failed to add a comment',
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
}

export function archiveTaskApi(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/dashboard/archive`, {
        method: 'POST',
        body: JSON.stringify({ task_id: id }),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin',
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.created) {
              dispatch(notify({
                title: 'Archive Task',
                message: 'Task archived successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
              dispatch(push('/pages/dashboards'));
              dispatch(archiveTask({ archived: id }));
            } else {
              dispatch(notify({
                title: 'Archive Task',
                message: 'Failed to archive the task',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        });
    }
  }
};

export function getPreView(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/viewTask/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin',
      })
        .then((response) => {
          return response.text();
        })
        .then(text => {
          if (text) {
            dispatch(getPreViewHtml({ html: text }));
          }
        })
    }
  }
};

export function getPdfPreView(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    const printButton = document.getElementById('view-print-btn');
    const finShow = printButton ? printButton.getAttribute("data-fin-show") : true;
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/getViewOfTaskByIdInPdf/${id}?finShow=${finShow}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin',
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          var link = document.createElement('a');
          link.href = data;
          link.download = 'Task Preview';
          link.click();

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
          }, 100);
        })
        .catch(response => {
          dispatch(notify({
            title: 'PDF Download',
            message: 'Failed to download PDF',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function updateTaskProject(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/setTaskProjectById/${id}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json && json.updated == true) {
            dispatch(notify({
              title: 'Set New Project',
              message: 'New project seted successfully.',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          } else if (json && json.code == 410) {
            dispatch(notify({
              title: 'Set New Project',
              message: json.detail,
              status: 'error',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
};



export function getPdfFileShipping(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/getViewOfTaskShippingByIdInPdf/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          const newBlob = new Blob([blob], {type: "application/pdf"});
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }
          const data = window.URL.createObjectURL(newBlob);
          window.open(data);

          setTimeout(function(){
          }, 100);

        })
        .catch(response => {
          dispatch(notify({
            title: 'PDF Download',
            message: 'Failed to download PDF',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getPdfFile(id, workOrderName) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/getViewOfTaskByIdInPdf/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          window.open(data);

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            //window.URL.revokeObjectURL(data);
          }, 100);

        })
        .catch(response => {
          dispatch(notify({
            title: 'PDF Download',
            message: 'Failed to download PDF',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getPdfFileInvoice(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/getPrintInvoiceInPdf/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          window.open(data);

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            //window.URL.revokeObjectURL(data);
          }, 100);

        })
        .catch(response => {
          dispatch(notify({
            title: 'PDF Download',
            message: 'Failed to download PDF',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function fetchTaskById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            getMaterialsList('')
              .then(res => {
                json.materials.forEach(m => {
                  if (m.material_id) {
                    const mat = res.options.find(o => o.value === m.material_id);
                    m.unit_of_measure = mat ? mat.unit_of_measure : '';
                  }
                });

                dispatch(getTaskByID({ current: json }));
              });
          }
        })
    }
  }
}

export function addNewTask(data, fromWhere='dashboard') {
  const fieldsData = JSON.parse(data.data);
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json && json.code != '400' && !json.error) {
              dispatch(addNewWO(data));
              localStorage.setItem('cameToWOFrom', fromWhere);
              localStorage.setItem('lastQuotesWoName', fieldsData[22]);
              dispatch(push('/pages/task/'+json.id));
              dispatch(notify({
                title: 'Add New Work Order',
                message: 'Task added successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else if (json && json.error) {
              if (json.error.exists !== null) {
                dispatch(notify({
                  title: 'Add New Work Order',
                  message: json.error.message ? json.error.message : 'Data for new Work Order is invalid',
                  status: 'error',
                  position: 'tr',
                  dismissible: true,
                  dismissAfter: 3000
                }));
              } else {

              }
            } else {
              dispatch(notify({
                title: 'Add New Work Order',
                message: 'Failed to add Work Order',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Work Order',
            message: 'Failed to add Work Order',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
};

export function getPdfOfTaskByFields(data, workOrderName) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/task/getPdfOfTaskByFields`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          // It is necessary to create a new blob object with mime-type explicitly set
          // otherwise only Chrome works like it should
          var newBlob = new Blob([blob], {type: "application/pdf"})

          // IE doesn't allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
            return;
          }

          // For other browsers:
          // Create a link pointing to the ObjectURL containing the blob.
          const data = window.URL.createObjectURL(newBlob);
          var link = document.createElement('a');
          link.href = data;
          link.download = workOrderName;
          link.click();

          setTimeout(function(){
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data);
          }, 100);

        })
    }
  }
};

export function getListOfFields() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/jobCardTemplate/getAllFieldsWithOptions`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getDynamicFields({ dynamicList: json }));
          }
        })
    }
  }
};

export function getWORecent(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/project/getWORecent/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
    }
  }
};

export function reopenArchiveTask(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/archive/task/${data.id}`, {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            if (json.code !== 410) {
              // dispatch(reopenArchive({ dynamicList: json }));
              dispatch(removeTaskFromArchive(data.id));
              dispatch(notify({
                title: 'Reopent Task',
                message: 'Task reopened successfully',
                status: 'success',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            } else {
              dispatch(notify({
                title: 'Reopent Task',
                message: 'Failed to reopen task',
                status: 'error',
                position: 'tr',
                dismissible: true,
                dismissAfter: 3000
              }));
            }
          }
        })
    }
  }
}

export function getSalesPersonsListAll() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch2(`${config.apiEndpoint}/task/getSalesPersonsList`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getSalesPersonsList({ salesPersonsList: json }));
          }
        })
    }
  }
}

export function getMaterialsList(filter, vendorsList = []) {
  return fetch2(`${config.apiEndpoint}/materials-inventory/search?filter=${filter}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user') ? store.get('user').api_token : ''}`
    },
    credentials: 'same-origin'
  })
    .then((response) => {
      return response.json();
    })
    .then(json => {
      const results = json.map((item) => {
        const vendor = vendorsList.find((v) => v.id === item.vendor_id);
        return ({
          label: `${item.name} (${item.sku} - ${vendor ? vendor.name : item.vendor_id})`,
          value: item.id,
          cost: item.cost,
          unit_of_measure: item.unit_of_measure
        })
      });
      return { options: results };
    })
    .catch(() => ({ options:[] }))
}

export function getMaterialsListByVendor(filter, vendorId) {
  console.log('getMaterialsListByVendor', filter, vendorId)
  return fetch2(`${config.apiEndpoint}/materials-inventory/search?filter=${filter}&vendor_id=${vendorId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `bearer ${store.get('user') ? store.get('user').api_token : ''}`
    },
    credentials: 'same-origin'
  })
    .then((response) => {
      return response.json();
    })
    .then(json => {
      const results = json.map((item) => {
        return ({
          label: `${item.name} (${item.sku})`,
          value: item.id,
          cost: item.cost,
        })
      });
      return { options: results };
    })
    .catch(() => ({ options: [] }))
}



// WEBPACK FOOTER //
// ./src/api/task.js